// Read base URL from environment, trim trailing slashes if present
const BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

/**
 * fetchApi - small wrapper around window.fetch with a base URL
 * @param {string} path - API path, e.g., "/api/D1/CreateD1"
 * @param {RequestInit} [init] - fetch init options
 * @returns {Promise<any>} - JSON-parsed response body (or Response if skipJson is true)
 */
export async function fetchApi(path, init) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const url = `${BASE_URL}${normalizedPath}`;

  // Attach session token from sessionStorage
  const sessionToken = sessionStorage.getItem("gs_session_token");
  const authHeaders = sessionToken ? { "Authorization": `Bearer ${sessionToken}` } : {};

  const res = await fetch(url, {
    ...(init || {}),
    headers: {
      "Content-Type": "application/json",
      ...authHeaders,
      ...((init && init.headers) || {}),
    },
  });

  // GS-020: Console logs commented out for production
  // console.log(`[fetchApi] Response: ${res.status} ${res.statusText} for ${url}`);

  // GS-SEC-029: If 401 Unauthorized, clear session and redirect to login
  if (res.status === 401) {
    sessionStorage.clear();
    window.location.replace('/');
    throw new Error('Session expired. Redirecting to login.');
  }

  if (!res.ok) {
    const body = await res.text();
    throw new Error(`HTTP ${res.status}: ${body || "Request failed"}`);
  }

  // If caller sets skipJson: true, return the raw Response instead of parsing
  if (init && init.skipJson) {
    return res;
  }
  return res.json();
}